import { css } from 'styled-system/css';

/** Page content column */
export const wrap = css({
  w: 'full',
  maxW: 'wrap',
  mx: 'auto',
  px: 'clamp(1rem, 3vw, 2rem)',
  _nebula: { px: 'clamp(1rem, 4vw, 2.5rem)' },
});

/** Vertical rhythm of a page section */
export const section = css({
  py: 'clamp(3.5rem, 8vw, 6.5rem)',
  _nebula: { py: 'clamp(3.5rem, 8vw, 7.5rem)' },
});

/** Page body under the nav */
export const page = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '9',
  pt: '10',
  pb: '20',
  _nebula: { pt: 'clamp(3rem, 6vw, 5rem)', gap: '10' },
});

/** 1 → 2 → 3 column grid */
export const grid3 = css({
  display: 'grid',
  gap: '6',
  gridTemplateColumns: {
    base: 'minmax(0, 1fr)',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(3, minmax(0, 1fr))',
  },
});

export const grid2 = css({
  display: 'grid',
  gap: '6',
  gridTemplateColumns: { base: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' },
});

export const grid4 = css({
  display: 'grid',
  gap: '6',
  gridTemplateColumns: {
    base: 'minmax(0, 1fr)',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(4, minmax(0, 1fr))',
  },
});

/** Hidden below the `lg` breakpoint (decorations that need room) */
export const hideMd = css({ lgDown: { display: 'none!' } });

export const muted = css({ color: 'fg.muted' });
export const subtle = css({ color: 'fg.subtle' });
export const accent = css({ color: 'fg.accent' });
export const hot = css({ color: 'fg.hot' });
